import { IArInvoiceRequest } from '../../interfaces/ar-invoices.interface'

export class GetArPaymentsSummary {
  static readonly type = '[ArPayments] Get Ar Payments Summary'
  constructor(public payload: IArInvoiceRequest) {}
}
